import React, { useState, useEffect } from "react";
import AppLayout from "./app-views/app-layout/AppLayout";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import TemplateListView from "./app-views/template-list-view/TemplateListView";
import ProductListView from "./app-views/product-list-view/ProductListView";
import TemplateEditorView from "./app-views/template-editor/TemplateEditorView";
import ModelerListView from "./app-views/modeler-list-view/ModelerListView";
import UserAccountView from "./app-views/user-account-view/UserAccountView";
import ModelerExecuteView from "./app-views/modeler-execute-view/ModelerExecuteView";
import ROUTES_PATH from "./constants/RouteConstants";
import "./styles/amplify-thems.css";
import { Auth, Hub } from "aws-amplify";
import { useHistory } from "react-router-dom";
import { onAuthUIStateChange } from "@aws-amplify/ui-components";
import AuthView from "./app-views/app-login/AuthView";
import LoadingComponent from "./components/loading-component/LoadingComponent";
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthStatusChecked, setIsAuthStatusChecked] = useState(false);  const history = useHistory();
  useEffect(() => {
    const handleStorageChange = () => {
      // Check if the storage still contains the needed auth information
      Auth.currentAuthenticatedUser()
        .then(() => setIsAuthenticated(true))
        .catch(() => setIsAuthenticated(false));
    };

    window.addEventListener("storage", handleStorageChange);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  useEffect(() => {
    return onAuthUIStateChange((nextAuthState, authData) => {
      if (nextAuthState === "signedin") {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    });
  }, [history]);
  useEffect(() => {
    const authListener = (data) => {
      const { payload } = data;
      if (payload.event === "signOut") {
        setIsAuthenticated(false);
      }
    };

    Hub.listen("auth", authListener);
    checkAuthState();

    // Clean up listener when component unmounts
    return () => Hub.remove("auth", authListener);
  }, [history]);

  const checkAuthState = async () => {
    try {
      await Auth.currentAuthenticatedUser();
      setIsAuthenticated(true);
    } catch (err) {
      setIsAuthenticated(false);
    } finally {
      setIsAuthStatusChecked(true); // Set this to true after checking auth status
    }
  };
  if (!isAuthStatusChecked) {
    return <LoadingComponent/>;; // or a loading component/spinner
  }


  if (!isAuthenticated) {
    // Render only the sign-in/sign-up components if not authenticated
    return (
      <AuthView onUserSignedIn={setIsAuthenticated}></AuthView>
    );
  }

  return (
    <AppLayout isAuthenticated={isAuthenticated}>
      <Switch>
        <Redirect exact from="/" to={`${ROUTES_PATH.modelers}managed`} />
        <Route
          path={`${ROUTES_PATH.templates}:access`}
          component={TemplateListView}
        />
        <Route
          // exact
          path={`${ROUTES_PATH.templateEditor}:templateId/`}
          component={TemplateEditorView}
        />
        <Route
          path={`${ROUTES_PATH.modelers}:access`}
          component={ModelerListView}
        />
        <Route
          // exact
          path={`${ROUTES_PATH.modelerExecute}:modelerId/:view`}
          component={ModelerExecuteView}
        />
        <Route path={ROUTES_PATH.marketplace} component={ProductListView} />
        <Route path={ROUTES_PATH.ACCOUNT} component={UserAccountView} />
      </Switch>
    </AppLayout>
  );
}
export default App;
